import { render } from "./index.html?vue&type=template&id=628ef9b4&ts=true"
import script from "./index.ts?vue&type=script&lang=ts"
export * from "./index.ts?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__